import { render, staticRenderFns } from "./search_result.vue?vue&type=template&id=79537a54&scoped=true&"
import script from "./search_result.vue?vue&type=script&lang=js&"
export * from "./search_result.vue?vue&type=script&lang=js&"
import style0 from "./search_result.vue?vue&type=style&index=0&id=79537a54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79537a54",
  null
  
)

export default component.exports